import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import "./SBI.css";
import { orderBy } from "lodash";
import { BsArrowLeft } from "react-icons/bs";
import { Spin, Result } from "antd";

import moment from "moment";
import * as yup from "yup";
import { onecodeAPI, sbiAPI } from "../AppConfig";
import { createYupSchema } from "../Components/DynamicForm/validation";
import ApplicationStatus from "./ApplicationStatus";
import DynamicForm from "./DynamicForm";
import Header from "./Header";
import Declaration from "./Declaration";
import mixpanel from "mixpanel-browser";

export default function SBIForm() {
  const [hash, setHash] = useState();
  const [formData, setFormData] = useState({});
  const [formValidations, setFormValidations] = useState({});
  const [formValues, setFormValues] = useState({});
  const [preFormValues, setPreFormValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [activeStep, setActiveStep] = useState();
  const [data, setdata] = useState({});
  const [stepCount, setStepCount] = useState(0);
  const [stepIds, setStepIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [partner, setPartner] = useState();

  // useEffect(()=>{
  //   onecodeAPI.post(`https://api-eks.staging.onecode.in/cc/integration/status-update`, {
  //     headers: {
  //       hash: 'DK8z8PLsO3mqKCSLfzrdEYVxApANwKsZEAGosDfdtcPvg2ZYU8bkDm8bON8XDJD5vbnISg1z3b8rJD3cupPOLQ==',
  //     },
  //     data:{
  //       method: 'GET'
  //     }
      
  //   });
  // }, [])

  // useEffect(() => {
   
  // },[])

  useEffect(() => {
    try {
      let params = new URLSearchParams(window.location.search);
      if (params.get("hash")) {
        setHash(encodeURIComponent(params.get("hash")));
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (hash) {
      getFieldsByPartner();
    } else {
      setLoading(false);
    }
  }, [hash]);

  const getFieldsByPartner = async () => {
    setLoading(true);
    let mobileNumber = null;
    let pageName = null;
    let pageNumber = null;
    let partnerId = null;
    let preFormValuesData = [];
    try {
      const autoFill = await onecodeAPI.post(`/public/AutoFillCC `, {
        hash: hash,
      });
      if (
        autoFill.data &&
        autoFill.data.body &&
        Array.isArray(autoFill.data.body)
      ) {
        preFormValuesData = autoFill.data.body;
        setPreFormValues(autoFill.data.body);
        if (preFormValuesData.length > 0) {
          const preData = preFormValuesData.filter(
            (pre) => pre.fieldCode == "mobileNumber"
          );
          if (preData.length > 0) {
            mobileNumber = preData[0].fieldValue;
            setPhoneNumber(mobileNumber);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
    try {
      const res = await onecodeAPI.post(`/partnerForm/partnerForm/v5`, {
        hash: hash,
        locale: "en",
      });

      if (res && res.data) {
        const result = processFormData(res.data, preFormValuesData);
        pageName = result._pageName
        pageNumber = result._pageNumber
        partnerId = result._partnerId
        mixpanel.track( "screen_view", {
          screen_name: partnerId === 219 ? "bajaj_form" : "sbi_form",
          page_name: pageName,
          page_number: pageNumber,
          partner_id : partnerId,
          phone_number: mobileNumber
        })
      }
    } catch (error) {
      setLoading(false);
      console.log("errror-customer", error);
    }
  };

  const processFormData = (data, preFormValuesData) => {
    let processedData = {};
    let validationData = {};
    let formValuesData = {};
    let processedDatatitle = {};
    let activeStep = null;
    let partnerData = null;
    if (data.partnerForms && data.partnerForms.length > 0) {
      const ocForm = data.partnerForms[0].ocForm;
      partnerData = data.partnerForms[0].partner;
      if (ocForm && ocForm.ocFieldGroups && ocForm.ocFieldGroups.length > 0) {
        activeStep = ocForm.ocFieldGroups[0].id;
        setActiveStep(activeStep);
        ocForm.ocFieldGroups.map((ocFieldGroup) => {
          if (ocFieldGroup && ocFieldGroup.ocFields) {
            const orderData = orderBy(
              ocFieldGroup.ocFields,
              ["orderNo"],
              ["asc"]
            );

            processedData = {
              ...processedData,
              [ocFieldGroup.id]: orderData,
            };

            processedDatatitle = {
              ...processedDatatitle,
              [ocFieldGroup.id]: {
                title: ocFieldGroup?.title,
                description: ocFieldGroup?.description,
              },
            };

            let ocFieldGroupData = {};
            orderData.map((field) => {
              let preValue = "";

              let initPreValue = "";
              if (preFormValuesData.length > 0) {
                const preData = preFormValuesData.filter(
                  (pre) => pre.fieldId == field.id
                );
                if (preData.length > 0) {
                  preValue =
                    preData[0].optionId &&
                    (field.type == "dropdown" || field.type == "radioButton")
                      ? preData[0].optionId
                      : preData[0].optionValue
                      ? preData[0].optionValue
                      : preData[0].fieldValue;
                  if ("companyName" == field.code && preValue != "") {
                    initPreValue = preData[0].fieldValue;
                  }
                }
              }

              if (field.type == "dateSelector") {
                try {
                  const checkData = moment(preValue, "YYYY-MM-DD");
                  if (!checkData.isValid()) {
                    preValue = "";
                  }
                } catch (error) {}
              }

              let initfieldData = {
                [field.id]: preValue ? preValue : "",
              };

              if ("companyName" == field.code && preValue != "") {
                initfieldData = {
                  ...initfieldData,
                  [`${field.id}_name_`]: initPreValue,
                };
              }

              ocFieldGroupData = {
                ...ocFieldGroupData,
                ...initfieldData,
              };
            });

            formValuesData = {
              ...formValuesData,
              [ocFieldGroup.id]: ocFieldGroupData,
            };

            const yepSchema = orderData.reduce(createYupSchema, {});

            validationData = {
              ...validationData,
              [ocFieldGroup.id]: yup.object().shape(yepSchema),
            };
          }
        });
      }
    }
    setPartner(partnerData);
    setFormData(processedData);
    setFormValidations(validationData);
    setFormValues(formValuesData);
    setLoading(false);
    setdata(processedDatatitle);
    setStepCount(Object.keys(processedData).length - 1);
    setStepIds(Object.keys(processedData));
    return {_pageName:processedDatatitle[activeStep]?.title,_pageNumber:Object.keys(processedData).length - 1,_partnerId:partnerData?.id}
  };

  const buildSubmitfield = (item, key, cloneData, finalData, formValues) => {
    if (
      (cloneData && item.code && item.code == "permanentAddressLine1") ||
      item.code == "permanentAddressLine2" ||
      item.code == "permanentAddressLine3" ||
      item.code == "PermanentZipCode" ||
      item.code == "PermanentCity" ||
      item.code == "PermanentState"
    ) {
      const keyFormData = formData[key];
      let value = "";
      if (item.code == "permanentAddressLine1") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "currentAddressLine1"
        );
        if (dependedField && dependedField.length > 0) {
          value = formValues[key][`${dependedField[0].id}`];
        }
      }
      if (item.code == "permanentAddressLine2") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "currentAddressLine2"
        );
        if (dependedField && dependedField.length > 0) {
          value = formValues[key][`${dependedField[0].id}`];
        }
      }

      if (item.code == "permanentAddressLine3") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "currentAddressLine3"
        );
        if (dependedField && dependedField.length > 0) {
          value = formValues[key][`${dependedField[0].id}`];
        }
      }
      if (item.code == "PermanentZipCode") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "zipCode"
        );
        if (dependedField && dependedField.length > 0) {
          value = formValues[key][`${dependedField[0].id}`];
        }
      }

      if (item.code == "PermanentCity") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "currentCity"
        );
        if (dependedField && dependedField.length > 0) {
          value = formValues[key][`${dependedField[0].id}`];
        }
      }

      if (item.code == "PermanentState") {
        const dependedField = keyFormData.filter(
          (formItem) => formItem.code == "currentState"
        );
        if (dependedField && dependedField.length > 0) {
          value = formValues[key][`${dependedField[0].id}`];
        }
      }

      return {
        fieldValue: value,
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    } else if (item.code == "OtherCompanyName") {
      const itemValue = finalData[key][`${item.id}_name_`]
        ? finalData[key][`${item.id}_name_`]
        : finalData[key][`${item.id}`];

      let newItemValue = finalData[key][`manualOtherCompanyName`];

      return {
        fieldValue:
          finalData[key][`${item.id}`] == "99999" ? newItemValue : itemValue,
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    } else if (item.code == "PermAddrSameAsResAddr") {
      return {
        fieldValue: finalData[`${item.id}`] ? "yes" : "no",
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    } else if (finalData && finalData[key] && finalData[key][`${item.id}`]) {
      return {
        fieldValue: finalData[key][`${item.id}`],
        fieldId: item.id,
        fieldTitle: item.name,
        fieldCode: item.code,
      };
    }
    return null;
  };

  const autoSaveApplication = async (finalData, key) => {
    try {
      const fields = [];

      let cloneData = false;

      formData[key].map((item) => {
        if (item.code == "companyName") {
          const itemValue = finalData[`${item.id}`];

          let newItemValue = finalData[`manualOtherCompanyName`];

          fields.push({
            fieldValue:
              finalData[`${item.id}`].toLowerCase() == "c"
                ? newItemValue
                : itemValue,
            fieldId: item.id,
            fieldTitle: item.name,
            fieldCode: item.code,
          });
        } else if (finalData && finalData && finalData[`${item.id}`]) {
          fields.push({
            fieldValue: finalData[`${item.id}`],
            fieldId: item.id,
            fieldTitle: item.name,
            fieldCode: item.code,
          });
        }
      });

      const requestData = fields;

      onecodeAPI.post(`public/autoSave`, requestData, {
        headers: {
          hash: hash,
        },
      });
    } catch (error) {
      console.log("saveApplication", error);
    }
  };

  const saveApplication = async (finalData) => {
    let phone = "";
    try {
      setSaving(true);
      setApplicationStatus({
        icon: "loading",
        reason:
          "Please wait while we set things up for you. This might take upto 30 seconds.",
        status: "Checking Eligibility",
      });
      const fields = [];

      let cloneData = false;
      Object.keys(formData).map(function (key) {
        formData[key].map((item) => {
          const keyFormData = formData[key];

          if (item.code == "PermAddrSameAsResAddr") {
            const dependedField = keyFormData.filter(
              (formItem) => formItem.code == "PermAddrSameAsResAddr"
            );
            if (dependedField && dependedField.length > 0) {
              if (finalData[key][`${dependedField[0].id}`]) {
                cloneData = true;
              }
            }
          }
        });
      });

      Object.keys(formData).map(function (key) {
        formData[key].map((item) => {
          if(item.code === 'PanNumber'){
            finalData[key][`${item.id}`] = finalData[key][`${item.id}`]?.toUpperCase?.();
          }
          if (item.code == "companyName") {
            const itemValue = finalData[key][`${item.id}_name_`]
              ? finalData[key][`${item.id}_name_`]
              : finalData[key][`${item.id}`];

            let newItemValue = finalData[key][`manualOtherCompanyName`];

            fields.push({
              fieldValue:
                finalData[key][`${item.id}`].toLowerCase() == "c"
                  ? newItemValue
                  : itemValue,
              fieldId: item.id,
              fieldTitle: item.name,
              fieldCode: item.code,
            });
          } else if (item.code == "PermAddrSameAsResAddr") {
            fields.push({
              fieldValue: finalData[key][`${item.id}`] ? "yes" : "no",
              fieldId: item.id,
              fieldTitle: item.name,
              fieldCode: item.code,
            });
          } else if (
            finalData &&
            finalData[key] &&
            finalData[key][`${item.id}`]
          ) {
            fields.push({
              fieldValue: finalData[key][`${item.id}`],
              fieldId: item.id,
              fieldTitle: item.name,
              fieldCode: item.code,
            });
          }
        });
      });

      fields.map(function (item) {
        if (item.fieldCode?.toLowerCase() === "mobilenumber") {
          phone = item.fieldValue;
      }
    });

      const requestData = fields;

      const api = partner?.id === 219 ? onecodeAPI : sbiAPI;

      const res = await api.post(`public/submitCCLead`, requestData, {
        headers: {
          hash: hash,
        },
      });
      setApplicationStatus(res.data.data);
      mixpanel.track("screen_view", {
        screen_name: partner?.id === 219 ? "bajaj_form_popup" : "sbi_form_popup",
        page_name: res.data.data?.status,
        partner_id: partner?.id,
        phone_number: phone,
      })
    } catch (error) {
      mixpanel.track("screen_view", {
        screen_name: partner?.id === 219 ? "bajaj_form_popup" : "sbi_form_popup",
        page_name: "We Apologise!_fe",
        partner_id: partner?.id,
        phone_number: phone,
      })
      const _applicationStatus = {
        icon: "exclamation",
        reason:
          "There was some technical error. Please try again after sometime.",
        status: "We Apologise!",
        // isRetryAllowed: true
      }
      setApplicationStatus(_applicationStatus);
    }
    setSaving(false);
  };

  const saveStepData = (data, key) => {
    setFormValues({ ...formValues, [key]: data });
    if (stepIds.indexOf(activeStep + "") < stepIds.length - 1) {
      setStepCount(stepCount - 1);
      autoSaveApplication(data, key);
      setActiveStep(activeStep + 1);
    } else if (stepIds.indexOf(activeStep + "") == stepIds.length - 1) {
      saveApplication({ ...formValues, [key]: data });
    }
  };
  const editApplicationForm = () => {
    getFieldsByPartner();
    setApplicationStatus(null);
  };

  const retryApplication = () => {
    saveApplication({ ...formValues });
  };

  if (!hash) {
    return (
      <div>
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
        />
      </div>
    );
  }
  if (loading) {
    return (
      <Spin
        spinning={loading}
        tip="Loading"
        size="large"
        style={{ fontSize: "20px", maxHeight: "100vh" }}
      >
        <div style={{ height: "100vh", width: "100%" }}></div>
      </Spin>
    );
  }

  return (
    !(partner?.isOnHold || partner?.isActive) ? (
    <Spin
      spinning={saving}
      tip="Eligibility Check"
      size="large"
      style={{ fontSize: "20px", maxHeight: "100vh" }}
    >
      <div
        style={{
          height: window.innerHeight,
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="sbi-main-div"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Header partner={partner} />

          {applicationStatus && applicationStatus.status ? (
            <ApplicationStatus
              applicationStatus={applicationStatus}
              editApplicationForm={editApplicationForm}
              retryApplication={retryApplication}
              partner={partner}
              phoneNumber={phoneNumber}
            />
          ) : (
            <>
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ width: "15%" }}>
                  <BsArrowLeft
                    onClick={() => {
                      const getData = setTimeout(() => {
                        if (stepIds.indexOf(activeStep + "") > 0) {
                          setActiveStep(activeStep - 1);
                          setStepCount(stepCount + 1);
                        }
                      }, 100);
                      mixpanel.track("back_button", {
                        screen_name:
                        partner?.id === 219 ? "bajaj_form" : "sbi_form",
                        page_name: data[activeStep]?.title,
                        page_number: stepCount,
                        partner_id: partner?.id,
                        phone_number: phoneNumber,
                      });
                    }}
                    style={{
                      marginLeft: "16px",
                      marginRight: "16px",
                      fontWeight: "600",
                      fontSize: 25,
                      color:
                        stepCount === Object.keys(data).length - 1
                          ? "#787878"
                          : "#000000",
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "16px",
                    fontWeight: "400",
                    fontSize: 20,
                  }}
                >
                  {data[activeStep]?.title}
                </div>
                <div
                  style={{
                    marginLeft: "16px",
                    fontWeight: "500",
                    fontSize: 12,
                    color: "#787878",
                    width: "90%",
                  }}
                >
                  {data[activeStep]?.description}
                </div>
                <DynamicForm
                  data={formData[activeStep]}
                  pageTitle={data[activeStep]?.title}
                  fullData={formData}
                  setActiveStep={setActiveStep}
                  activeStep={activeStep}
                  saveStepData={saveStepData}
                  stepCount={stepCount}
                  setStepCount={setStepCount}
                  stepIds={stepIds}
                  formValidations={formValidations}
                  hash={hash}
                  preFormValues={preFormValues}
                  formValues={formValues}
                  setShowModal={setShowModal}
                  phoneNumber={phoneNumber}
                  dateFormat="YYYY-MM-DD"
                  partner={partner}
                />
              </div>
            </>
          )}
        </div>
      </div>
      {showModal && (
        <Declaration partner={partner} setShowModal={setShowModal} />
      )}
    </Spin> ) :
    <ApplicationStatus
    applicationStatus={{
      icon: "grey_exclamation",
      message:
        "Please try again later",
      status: "On Hold",
    }}
            />
  );
}
